<template>
    <v-card
        elevation="0"
        height="340"
        v-if="avatarPack.id"
    >
        <v-card
            elevation="0"
            @click="setFavorite"
            @mouseover="hover = true"
            @mouseleave="hover = false"
        >
            <v-row justify="center" class="f-row">
                <img
                    :src="`https://assets.beereaders.com/avatar/${avatarPack.avatarDTOList[0].name}/${avatarPack.avatarDTOList[0].value}`"
                    class="avatar-img-top transition-all"
                    @load="handleLoaded1"
                    alt="Av"
                />
                <v-skeleton-loader
                    v-if="!loaded1"
                    class="mt-3 rounded-circle position-absolute opacity-none"
                    height="130"
                    width="130"
                    type="image"
                    :transition="'scale-transition'"
                />
            </v-row>
            <v-row justify="center" class="s-row">
                <v-col cols="6">
                    <img
                        :src="`https://assets.beereaders.com/avatar/${avatarPack.avatarDTOList[1].name}/${avatarPack.avatarDTOList[1].value}`"
                        class="avatar-img-r transition-all"
                        @load="handleLoaded2"
                        alt="Av"
                    />
                    <v-skeleton-loader
                        v-if="!loaded2"
                        class="avatar-img-r skeleton-avatar-img rounded-circle position-absolute opacity-none"
                        height="130"
                        width="130"
                        type="image"
                        :transition="'scale-transition'"
                    />
                </v-col>
                <v-col cols="6">
                    <img
                        :src="`https://assets.beereaders.com/avatar/${avatarPack.avatarDTOList[2].name}/${avatarPack.avatarDTOList[2].value}`"
                        class="avatar-img-l transition-all"
                        @load="handleLoaded3"
                        alt="Av"
                    />
                    <v-skeleton-loader
                        v-if="!loaded3"
                        class="avatar-img-l skeleton-avatar-img rounded-circle position-absolute opacity-none"
                        height="130"
                        width="130"
                        type="image"
                        :transition="'scale-transition'"
                    />
                </v-col>
            </v-row>
            <v-overlay absolute opacity="0" style="cursor:pointer;">
                <v-img :src="favoriteSrc" class="mt-3 bg-orange border-radius-5" height="50" max-width="60" v-show="hover"></v-img>
            </v-overlay>
        </v-card>
        <v-row justify="center">
            <v-chip
                rounded
                color="#FF6F3A"
                class="py-5 px-6 white--text text-body-1 font-weight-bold"
                @click="setToBuyAvatar"
                v-if="!avatarPack.purchased"
            >
                {{ packPrice }} Beecoins
            </v-chip>
        </v-row>
        <v-row justify="center" class="my-2" v-show="!devPending">
            <v-img
                src="/img/user/star-filled.svg"
                class="mx-1"
                max-height="15"
                max-width="15"
                v-for="n in [0,1,2,3]"
                :key="n + '-filled'"
            />
            <v-img
                src="/img/user/star.svg"
                class="mx-1"
                max-height="15"
                max-width="15"
            />
        </v-row>
        <v-row justify="center" class="my-2 color-text">
            {{ $t('store.pack_of') }}
            <br/>
            {{ avatarPack.avatarDTOList.length }}
            {{ $t('store.avatars') }}
        </v-row>
    </v-card>
</template>

<script>

import { mapState } from 'vuex'
import AvatarFavoriteService from '../../services/avatarFavorite'

const defaultAvatarPack = {
    active: false,
    avatarDTOList: [],
    favorite: false,
    id: 0,
    name: '',
    purchased: false
}

export default {
    props: {
        avatarPack: {
            type: Object,
            default: defaultAvatarPack,
        }
    },
    data() {
        return {
            devPending: true,
            favorite: false,
            hover: false,
            loaded1: false,
            loaded2: false,
            loaded3: false
        }
    },
    mounted() {
        this.favorite = this.avatarPack.favorite
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
        favoriteSrc() {
            return this.favorite ? '/img/user/icon-favorite-selected.svg' : '/img/user/icon-favorite.svg'
        },
        packPrice() {
            let price = 0
            this.avatarPack.avatarDTOList.forEach(element => {
                price += element.price
            });
            return price
        }
    },
    methods: {
        handleLoaded1() {
            this.loaded1 = true
        },
        handleLoaded2() {
            this.loaded2 = true
        },
        handleLoaded3() {
            this.loaded3 = true
        },
        setFavorite () {
            this.favorite = !this.favorite
            this.$emit('favorite',
                { id: this.avatarPack.id, favorite: this.favorite }
            )
            if (this.favorite) {
                AvatarFavoriteService.createFavorite(
                    this.user.id,
                    this.avatarPack.id
                )
                .catch((error) => console.error(error))
            } else {
                AvatarFavoriteService.deleteFavorite(
                    this.user.id,
                    this.avatarPack.id
                )
                .catch((error) => console.error(error))
            }
        },
        setToBuyAvatar() {
            this.$emit('toBuy', this.avatarPack)
        }
    }
}
</script>

<style lang="css" scoped>
.color-text {
    color: #4A3216;
}
.f-row {
    height: 45%;
}
.s-row {
    height: 45%;
    margin-top: -60px;
}
.avatar-img-top {
    display: block;
    height: 100%;
    width: 50%;
    z-index: 1;
}
.avatar-img-r {
    display: block;
    height: 100%;
    margin-left: 20px;
    width: 100%;
}
.avatar-img-l {
    display: block;
    height: 100%;
    margin-left: -20px;
    width: 100%;
}
.skeleton-avatar-img {
    margin-top: -130px;
}
.avatar-to-buy {
    opacity: 0.3;
}
.bg-orange {
    background-color:#FF6F3A;
}
</style>
